import React from 'react';

import AuthenticationLayout from '#app/Layout/AuthenticationLayout/AuthenticationLayout';
import MainLayout from '#app/Layout/MainLayout/MainLayout';
import ShopLayout from '#app/Layout/ShopLayout/ShopLayout';
import AuthenticationReducer from '#app/Reducer/AuthenticationReducer';
import ShopPaymentList from '#app/View/Accounting';
import AdministratorLogCarrierList from '#app/View/Administrator/LogCarrier/AdministratorLogCarrierList';
import AdministratorLogPrinterList from '#app/View/Administrator/LogPrinter/AdministratorLogPrinterList';
import AdministratorLogSyliusList from '#app/View/Administrator/LogSylius/AdministratorLogSyliusList';
import AdministratorRequestAsyncList from '#app/View/Administrator/RequestAsync/AdministratorRequestAsyncList';
import AdministratorUser from '#app/View/Administrator/User/AdministratorUser';
import AdministratorUserList from '#app/View/Administrator/User/AdministratorUserList';
// Views
import AuthenticationLogin from '#app/View/Authentication/Login';
import ForgotPasswordRequest from '#app/View/Authentication/ResetPassword/ForgotPasswordRequest';
import ResetPassword from '#app/View/Authentication/ResetPassword/ResetPassword';
import RefundList from '#app/View/Billing/RefundList/RefundList';
import ReshipmentList from '#app/View/Billing/RefundList/ReshipmentList';
import BuyOrderPurveyor from '#app/View/Buy/OrderPurveyor/BuyOrderPurveyor';
import BuyOrderPurveyorList from '#app/View/Buy/OrderPurveyor/BuyOrderPurveyorList';
import BuyProduct from '#app/View/Buy/Product/BuyProduct';
import BuyProductList from '#app/View/Buy/Product/BuyProductList';
import BuyProductManageWeightList from '#app/View/Buy/Product/BuyProductManageWeightList';
import BuyPurveyor from '#app/View/Buy/Purveyor/BuyPurveyor';
import BuyPurveyorContactList from '#app/View/Buy/Purveyor/BuyPurveyorComponents/BuyPurveyorContactList';
import BuyPurveyorList from '#app/View/Buy/Purveyor/BuyPurveyorList';
import OrderClientLitige from '#app/View/ClientService/OrderClientLitige';
import OrderClientLitigeList from '#app/View/ClientService/OrderClientLitigeList';
import InventoryManagementDeposit from '#app/View/InventoryManagement/Deposit/InventoryManagementDeposit';
import InventoryManagementDepositList from '#app/View/InventoryManagement/Deposit/InventoryManagementDepositList';
import InventoryManagementPicking from '#app/View/InventoryManagement/Deposit/Picking';
import InventoryManagementInventoryDepositInventory from '#app/View/InventoryManagement/Inventory/DepositInventory';
import InventoryManagementInventoryList from '#app/View/InventoryManagement/Inventory/InventoryManagementInventoryList';
import InventoryManagementDepositMoveList from '#app/View/InventoryManagement/Movement/InventoryManagementMovementList';
import InventoryManagementPreparerOrderList from '#app/View/InventoryManagement/Preparer/InventoryManagementPreparerOrderList';
import InventoryManagementPreparerManager from '#app/View/InventoryManagement/PreparerManager';
import InventoryManagementReceiptOrderPurveyor from '#app/View/InventoryManagement/ReceiptOrderPurveyor/InventoryManagementReceiptOrderPurveyor';
import InventoryManagementReceiptOrderPurveyorList from '#app/View/InventoryManagement/ReceiptOrderPurveyor/InventoryManagementReceiptOrderPurveyorList';
import InventoryManagementReturnOrder from '#app/View/InventoryManagement/ReturnOrder/InventoryManagementReturnOrder';
import InventoryManagementReturnOrderShop from '#app/View/InventoryManagement/ReturnOrder/SellerInventoryManagementReturnOrder';
import MovementStock from '#app/View/InventoryManagement/Stock/MovementStock';
import InventoryManagementValorisationStockList from '#app/View/InventoryManagement/ValorisationStock/InventoryManagementValorisationStockList';
import SaleClient from '#app/View/Sale/Client/SaleClient';
import SaleClientList from '#app/View/Sale/Client/SaleClientList';
import SaleOrderClient from '#app/View/Sale/OrderClient/SaleOrderClient';
import SaleOrderClientList from '#app/View/Sale/OrderClient/SaleOrderClientList';
import SalePromo from '#app/View/Sale/Promo/SalePromo';
import SalePromoList from '#app/View/Sale/Promo/SalePromoList';
import SettingFamilyList from '#app/View/Setting/FamilyList/SettingFamilyList';
import SettingFlavorList from '#app/View/Setting/FlavorList/SettingFlavorList';
import SettingGalenicList from '#app/View/Setting/GalenicList/SettingGalenicList';
import SettingLabelPrinterList from '#app/View/Setting/LabelPrinterList/SettingLabelPrinterList';
import SettingMarkList from '#app/View/Setting/MarkList/SettingMarkList';
import SettingPackSizeList from '#app/View/Setting/PackSizeList/SettingPackSizeList';
import SettingPaymentTermsList from '#app/View/Setting/PaymentTermsList/SettingPaymentTermsList';
import SettingPrinterList from '#app/View/Setting/PrinterList/SettingPrinterList';
import SettingProductTypeList from '#app/View/Setting/ProductTypeList/SettingProductTypeList';
import SettingPurveyorTypeList from '#app/View/Setting/PurveyorTypeList/SettingPurveyorTypeList';
import SettingSectorList from '#app/View/Setting/SectorList/SettingSectorList';
import SettingSubfamilyList from '#app/View/Setting/SubfamilyList/SettingSubfamilyList';
import SettingTvaCountryList from '#app/View/Setting/TvaCountryList/SettingTvaCountryList';
import SettingTvaList from '#app/View/Setting/TvaList/SettingSectorList';
import ShopCashRegister from '#app/View/Shop/CashRegister/ShopCashRegister';
import ShopCashRegisterClosed from '#app/View/Shop/CashRegister/ShopCashRegisterClosed';
import ShopCashSignOpening from '#app/View/Shop/CashRegister/ShopCashSignOpening';
import ShopProductsList from '#app/View/Shop/Products/ShopProductsList';
import CreateReappro from '#app/View/Shop/Reappro/CreateReappro';
import ShopEditReappro from '#app/View/Shop/Reappro/EditReappro';
import ListReappro from '#app/View/Shop/Reappro/ListReappro';
import ReceptionReappro from '#app/View/Shop/Reappro/ReceptionReappro';
import EditClient from '#app/View/Shop/Sale/EditClient';
import ShopSaleOrderClient from '#app/View/Shop/Sale/OrderClient';
import SelectClient from '#app/View/Shop/Sale/SelectClient';
import SelectProducts from '#app/View/Shop/Sale/SelectProducts';
import ShopSalesList from '#app/View/Shop/Sale/ShopSalesList';
import ShopSalesListToday from '#app/View/Shop/Sale/ShopSalesListToday';
import ClosingShopEdit from '#app/View/ShopManagement/Gestion/ClosingShopEdit';
import ClosingShopList from '#app/View/ShopManagement/Gestion/ClosingShopList';
import ShopManagementListReappro from '#app/View/ShopManagement/Reappro/ShopManagementReapproList';
import ShopManagementShopRegionList from '#app/View/ShopManagement/Region/ShopManagementRegionList';
import ShopManagementShop from '#app/View/ShopManagement/Shop/ShopManagementShop';
import ShopManagementShopList from '#app/View/ShopManagement/Shop/ShopManagementShopList';
import StatisticBuyCa from '#app/View/Statistic/Buy/StatisticBuyCa';
import StatisticBuyPortfolioDetails from '#app/View/Statistic/Buy/StatisticBuyPortfolioDetails';
import StatisticMark from '#app/View/Statistic/Mark/StatisticMark';
import StatisticOrder from '#app/View/Statistic/Order/StatisticOrder';
import StatisticPreparation from '#app/View/Statistic/Preparation/StatisticPreparation';
import StatisticSaleOrderReports from '#app/View/Statistic/Sale/OrderReports/StatisticSaleOrderReports';
import SalesLast12Months from '#app/View/Statistic/Sale/SalesLast12Months';
import StatisticSalePayment from '#app/View/Statistic/Sale/StatisticSalePayment';
import SalesStatisticsList from '#app/View/Statistic/SalesStatistics/SalesStatisticsList';
import StatisticTrade from '#app/View/Statistic/Trade/StatisticTrade';
import StatisticTradeRetail from '#app/View/Statistic/Trade/StatisticTradeRetail';

export type RouteConfig = {
  path: string;
  view: React.ComponentType;
  layout: typeof AuthenticationLayout | typeof MainLayout | typeof ShopLayout;
  roles: string[];
  match?: RegExp;
};

const routing: Record<string, RouteConfig> = {
  // Authentication
  authentication_login: {
    path: '/authentication/login',
    view: AuthenticationLogin,
    layout: AuthenticationLayout,
    roles: [],
  },
  forgot_password_request: {
    path: '/authentication/reset-password-request',
    view: ForgotPasswordRequest,
    layout: AuthenticationLayout,
    roles: [],
  },
  reset_password: {
    path: '/reset-password/reset/:token',
    match: /\/reset-password\/reset\/(.*)/,
    view: ResetPassword,
    layout: AuthenticationLayout,
    roles: [],
  },

  // Buy
  buy_product_list: {
    path: '/buy/product/list',
    view: BuyProductList,
    layout: MainLayout,
    roles: ['ROLE_BUY_PRODUCT', 'ROLE_BUY_PRODUCT_LIST'],
  },
  buy_product: {
    path: '/buy/product/:id',
    match: /\/buy\/product.*/,
    view: BuyProduct,
    layout: MainLayout,
    roles: ['ROLE_BUY_PRODUCT', 'ROLE_BUY_PRODUCT_GET', 'ROLE_BUY_PRODUCT_ADD'],
  },
  buy_order_purveyor_list: {
    path: '/buy/order-purveyor/list',
    view: BuyOrderPurveyorList,
    layout: MainLayout,
    roles: ['ROLE_BUY_ORDER_PURVEYOR', 'ROLE_BUY_ORDER_PURVEYOR_LIST'],
  },
  buy_product_manage_weight_list: {
    path: '/buy/product/manage-weight/list',
    view: BuyProductManageWeightList,
    layout: MainLayout,
    roles: ['ROLE_MANAGER_ENTREPOT', 'ROLE_MANAGER_ENTREPOT_ARTICLES_EDIT'],
  },
  buy_order_purveyor: {
    path: '/buy/order-purveyor/:id',
    match: /\/buy\/order-purveyor.*/,
    view: BuyOrderPurveyor,
    layout: MainLayout,
    roles: ['ROLE_BUY_ORDER_PURVEYOR', 'ROLE_BUY_ORDER_PURVEYOR_GET', 'ROLE_BUY_ORDER_PURVEYOR_ADD'],
  },
  buy_purveyor_list: {
    path: '/buy/purveyor/list',
    view: BuyPurveyorList,
    layout: MainLayout,
    roles: ['ROLE_BUY_PURVEYOR', 'ROLE_BUY_PURVEYOR_LIST'],
  },
  buy_purveyor: {
    path: '/buy/purveyor/:id',
    match: /\/buy\/purveyor.*/,
    view: BuyPurveyor,
    layout: MainLayout,
    roles: ['ROLE_BUY_PURVEYOR', 'ROLE_BUY_PURVEYOR_ADD', 'ROLE_BUY_PRODUCT_GET'],
  },
  buy_purveyor_contact_list: {
    path: '/buy/purveyor/:id/contact/list',
    view: BuyPurveyorContactList,
    layout: MainLayout,
    roles: ['ROLE_BUY_PURVEYOR', 'ROLE_BUY_PURVEYOR_LIST'],
  },

  // Inventory Management
  inventory_management_deposit_list: {
    path: '/inventory-management/deposit/list',
    view: InventoryManagementDepositList,
    layout: MainLayout,
    roles: ['ROLE_INVENTORY_MANAGEMENT_DEPOSIT', 'ROLE_INVENTORY_MANAGEMENT_DEPOSIT_LIST'],
  },
  inventory_management_deposit: {
    path: '/inventory-management/deposit/:id',
    match: /\/inventory-management\/deposit.*/,
    view: InventoryManagementDeposit,
    layout: MainLayout,
    roles: [
      'ROLE_INVENTORY_MANAGEMENT_DEPOSIT',
      'ROLE_INVENTORY_MANAGEMENT_DEPOSIT_ADD',
      'ROLE_INVENTORY_MANAGEMENT_DEPOSIT_GET',
    ],
  },
  inventory_management_inventory_list: {
    path: '/inventory-management/inventory/list',
    view: InventoryManagementInventoryList,
    layout: MainLayout,
    roles: ['ROLE_INVENTORY_MANAGEMENT_INVENTORY', 'ROLE_INVENTORY_MANAGEMENT_INVENTORY_LIST'],
  },
  inventory_management_inventory_deposit_inventory: {
    path: '/inventory-management/inventory/deposit/:deposit/inventory',
    match: /\/inventory-management\/inventory\/deposit.*/,
    view: InventoryManagementInventoryDepositInventory,
    layout: MainLayout,
    roles: [
      'ROLE_INVENTORY_MANAGEMENT_INVENTORY',
      'ROLE_INVENTORY_MANAGEMENT_INVENTORY_ADD',
      'ROLE_INVENTORY_MANAGEMENT_INVENTORY_VALIDATED',
    ],
  },
  inventory_management_movement_list: {
    path: '/inventory-management/movement/list',
    view: InventoryManagementDepositMoveList,
    layout: MainLayout,
    roles: ['ROLE_INVENTORY_MANAGEMENT_MOVEMENT', 'ROLE_INVENTORY_MANAGEMENT_MOVEMENT_LIST'],
  },
  inventory_management_movement_stock: {
    path: '/inventory-management/movement/stock',
    view: MovementStock,
    layout: MainLayout,
    roles: ['ROLE_INVENTORY_MANAGEMENT_MOVEMENT', 'ROLE_INVENTORY_MANAGEMENT_MOVEMENT_LIST'],
  },
  inventory_management_receipt_order_purveyor_list: {
    path: '/inventory-management/receipt-order-purveyor/list',
    view: InventoryManagementReceiptOrderPurveyorList,
    layout: MainLayout,
    roles: [
      'ROLE_INVENTORY_MANAGEMENT_RECEIPT_ORDER_PURVEYOR',
      'ROLE_INVENTORY_MANAGEMENT_RECEIPT_ORDER_PURVEYOR_LIST',
    ],
  },
  inventory_management_receipt_order_purveyor: {
    path: '/inventory-management/receipt-order-purveyor/:id',
    match: /\/inventory-management\/receipt-order-purveyor.*/,
    view: InventoryManagementReceiptOrderPurveyor,
    layout: MainLayout,
    roles: [
      'ROLE_INVENTORY_MANAGEMENT_RECEIPT_ORDER_PURVEYOR',
      'ROLE_INVENTORY_MANAGEMENT_RECEIPT_ORDER_PURVEYOR_EDIT',
      'ROLE_INVENTORY_MANAGEMENT_RECEIPT_ORDER_PURVEYOR_GET',
    ],
  },
  inventory_management_preparer_manager: {
    path: '/inventory-management/preparer-manager',
    view: InventoryManagementPreparerManager,
    layout: MainLayout,
    roles: ['ROLE_INVENTORY_MANAGEMENT_PREPARER_MANAGER'],
  },
  inventory_management_preparer: {
    path: '/inventory-management/preparer',
    view: InventoryManagementPreparerOrderList,
    layout: MainLayout,
    roles: ['ROLE_INVENTORY_MANAGEMENT_PREPARER'],
  },
  inventory_management_valorisation_stock_list: {
    path: '/inventory-management/valorisation-stock/list',
    view: InventoryManagementValorisationStockList,
    layout: MainLayout,
    roles: ['ROLE_INVENTORY_MANAGEMENT_VALORISATION_STOCK'],
  },
  inventory_management_return_order: {
    path: '/inventory-management/return-order',
    view: InventoryManagementReturnOrder,
    layout: MainLayout,
    roles: ['ROLE_INVENTORY_MANAGEMENT_RETURN_ORDER'],
  },
  inventory_deposit_picking: {
    path: '/inventory-management/picking',
    view: InventoryManagementPicking,
    layout: MainLayout,
    roles: ['ROLE_INVENTORY_MANAGEMENT_DEPOSIT', 'ROLE_INVENTORY_MANAGEMENT_DEPOSIT_LIST'],
  },
  inventory_shop_management_inventory: {
    path: '/shop/inventory-management/inventory',
    view: InventoryManagementInventoryDepositInventory,
    layout: ShopLayout,
    roles: [
      'ROLE_INVENTORY_MANAGEMENT_INVENTORY',
      'ROLE_INVENTORY_MANAGEMENT_INVENTORY_ADD',
      'ROLE_INVENTORY_MANAGEMENT_INVENTORY_VALIDATED',
    ],
  },
  inventory_shop_management_return_order: {
    path: '/shop/inventory-management/return-order',
    view: InventoryManagementReturnOrderShop,
    layout: ShopLayout,
    roles: ['ROLE_INVENTORY_MANAGEMENT_RETURN_ORDER'],
  },

  // Sale
  sale_client_list: {
    path: '/sale/client/list',
    view: SaleClientList,
    layout: MainLayout,
    roles: ['ROLE_SALE_CLIENT', 'ROLE_SALE_CLIENT_LIST'],
  },
  sale_client: {
    path: '/sale/client/:uuid',
    match: /\/sale\/client.*/,
    view: SaleClient,
    layout: MainLayout,
    roles: ['ROLE_SALE_CLIENT', 'ROLE_SALE_CLIENT_GET'],
  },
  sale_order_client_list: {
    path: '/sale/order-client/list/:orderClientState?',
    match: /\/sale\/order-client\/list(\/\d+)?$/,
    view: SaleOrderClientList,
    layout: MainLayout,
    roles: ['ROLE_SALE_ORDER_CLIENT', 'ROLE_SALE_ORDER_CLIENT_LIST'],
  },
  sale_order_client: {
    path: '/sale/order-client/:uuid',
    match: /\/sale\/order-client.*/,
    view: SaleOrderClient,
    layout: MainLayout,
    roles: ['ROLE_SALE_ORDER_CLIENT', 'ROLE_SALE_ORDER_CLIENT_GET'],
  },
  sale_promo_list: {
    path: '/sale/promo/list',
    view: SalePromoList,
    layout: MainLayout,
    roles: ['ROLE_SALE_PROMO', 'ROLE_SALE_PROMO_LIST'],
  },
  sale_promo: {
    path: '/sale/promo/edit/:id',
    match: /\/sale\/promo.*/,
    view: SalePromo,
    layout: MainLayout,
    roles: ['ROLE_SALE_PROMO', 'ROLE_SALE_PROMO_GET'],
  },
  sale_promo_add: {
    path: '/sale/promo/add',
    view: SalePromo,
    layout: MainLayout,
    roles: ['ROLE_SALE_PROMO', 'ROLE_SALE_PROMO_GET'],
  },

  // Shop Management
  shop_management_shop_list: {
    path: '/shop-management/shop/list',
    view: ShopManagementShopList,
    layout: MainLayout,
    roles: ['ROLE_SHOP_MANAGEMENT_SHOP', 'ROLE_SHOP_MANAGEMENT_SHOP_LIST'],
  },
  shop_management_shop: {
    path: '/shop-management/shop/:id',
    match: /\/shop-management\/shop.*/,
    view: ShopManagementShop,
    layout: MainLayout,
    roles: ['ROLE_SHOP_MANAGEMENT_SHOP', 'ROLE_SHOP_MANAGEMENT_SHOP_ADD', 'ROLE_SHOP_MANAGEMENT_SHOP_GET'],
  },
  shop_management_shop_region_list: {
    path: '/shop-management/shop-region/list',
    view: ShopManagementShopRegionList,
    layout: MainLayout,
    roles: ['ROLE_SHOP_MANAGEMENT_SHOP_REGION', 'ROLE_SHOP_MANAGEMENT_SHOP_REGION_LIST'],
  },
  shop_management_shop_list_reappro: {
    path: '/shop-management/shop/list/reappro',
    view: ShopManagementListReappro,
    layout: MainLayout,
    roles: ['ROLE_REAPPRO_SHOP', 'ROLE_REAPPRO_SHOP_LIST'],
  },
  shop_management_shop_reappro: {
    path: '/shop-management/shop/reappro/edit/:id',
    match: /\/shop-management\/shop\/reappro\/edit.*/,
    view: ShopEditReappro,
    layout: MainLayout,
    roles: ['ROLE_SHOP_MANAGEMENT_SHOP_GET_REAPPRO', 'ROLE_SHOP_MANAGEMENT_SHOP'],
  },
  shop_management_shop_closing_list: {
    path: '/shop-management/shop/closing/list',
    view: ClosingShopList,
    layout: MainLayout,
    roles: ['ROLE_SHOP_MANAGEMENT_SHOP', 'ROLE_SHOP_MANAGEMENT_SHOP_CLOSING'],
  },
  shop_management_shop_closing: {
    path: '/shop-management/shop/closing/:id',
    match: /\/shop-management\/shop\/closing.*/,
    view: ClosingShopEdit,
    layout: MainLayout,
    roles: ['ROLE_SHOP_MANAGEMENT_SHOP', 'ROLE_SHOP_MANAGEMENT_SHOP_ADD', 'ROLE_SHOP_MANAGEMENT_SHOP_GET'],
  },

  // Accounting
  billing_refund_list: {
    path: '/billing/refund/list',
    view: RefundList,
    layout: MainLayout,
    roles: ['ROLE_BILLING_CREDIT', 'ROLE_BILLING_CREDIT_LIST'],
  },
  billing_reshipment_list: {
    path: '/billing/reshipment/list',
    view: ReshipmentList,
    layout: MainLayout,
    roles: ['ROLE_BILLING_CREDIT', 'ROLE_BILLING_CREDIT_LIST'],
  },
  accounting_shop_payment: {
    path: '/accounting/shop-payment/list',
    view: ShopPaymentList,
    layout: MainLayout,
    roles: ['ROLE_ACCOUNTING', 'ROLE_ACCOUNTING_SHOP_PAYMENT_LIST'],
  },

  // Client Service
  client_service_order_client_litige_list: {
    path: '/client-service/order-client-litige/list',
    view: OrderClientLitigeList,
    layout: MainLayout,
    roles: ['ROLE_CLIENT_SERVICE_ORDER_CLIENT_LITIGE', 'ROLE_CLIENT_SERVICE_ORDER_CLIENT_LITIGE_LIST'],
  },
  client_service_order_client_litige: {
    path: '/client-service/order-client-litige/:uuid',
    match: /\/client-service\/order-client-litige.*/,
    view: OrderClientLitige,
    layout: MainLayout,
    roles: ['ROLE_CLIENT_SERVICE_ORDER_CLIENT_LITIGE', 'ROLE_CLIENT_SERVICE_ORDER_CLIENT_LITIGE_GET'],
  },

  // Setting
  setting_mark_list: {
    path: '/setting/mark/list',
    view: SettingMarkList,
    layout: MainLayout,
    roles: ['ROLE_SETTING_MARK', 'ROLE_SETTING_MARK_LIST'],
  },
  setting_product_type_list: {
    path: '/setting/product-type/list',
    view: SettingProductTypeList,
    layout: MainLayout,
    roles: ['ROLE_SETTING_PRODUCT_TYPE', 'ROLE_SETTING_PRODUCT_TYPE_LIST'],
  },
  setting_galenic_list: {
    path: '/setting/galenic/list',
    view: SettingGalenicList,
    layout: MainLayout,
    roles: ['ROLE_SETTING_GALENIC', 'ROLE_SETTING_GALENIC_LIST'],
  },
  setting_sector_list: {
    path: '/setting/sector/list',
    view: SettingSectorList,
    layout: MainLayout,
    roles: ['ROLE_SETTING_SECTOR', 'ROLE_SETTING_SECTOR_LIST'],
  },
  setting_pack_size_list: {
    path: '/setting/pack-size/list',
    view: SettingPackSizeList,
    layout: MainLayout,
    roles: ['ROLE_SETTING_PACK_SIZE', 'ROLE_SETTING_PACK_SIZE_LIST'],
  },
  setting_flavor_list: {
    path: '/setting/flavor/list',
    view: SettingFlavorList,
    layout: MainLayout,
    roles: ['ROLE_SETTING_FLAVOR', 'ROLE_SETTING_FLAVOR_LIST'],
  },
  setting_purveyor_type_list: {
    path: '/setting/purveyor-type/list',
    view: SettingPurveyorTypeList,
    layout: MainLayout,
    roles: ['ROLE_SETTING_PURVEYOR_TYPE', 'ROLE_SETTING_PURVEYOR_TYPE_LIST'],
  },
  setting_payment_terms_list: {
    path: '/setting/payment-terms/list',
    view: SettingPaymentTermsList,
    layout: MainLayout,
    roles: ['ROLE_SETTING_PAYMENT_TERMS', 'ROLE_SETTING_PAYMENT_TERMS_LIST'],
  },
  setting_tva_list: {
    path: '/setting/tva/list',
    view: SettingTvaList,
    layout: MainLayout,
    roles: ['ROLE_SETTING_TVA', 'ROLE_SETTING_TVA_LIST'],
  },
  setting_family_list: {
    path: '/setting/family/list',
    view: SettingFamilyList,
    layout: MainLayout,
    roles: ['ROLE_SETTING_FAMILY', 'ROLE_SETTING_FAMILY_LIST'],
  },
  setting_subfamily_list: {
    path: '/setting/subfamily/list',
    view: SettingSubfamilyList,
    layout: MainLayout,
    roles: ['ROLE_SETTING_SUBFAMILY', 'ROLE_SETTING_SUBFAMILY_LIST'],
  },
  setting_printer_list: {
    path: '/setting/printer/list',
    view: SettingPrinterList,
    layout: MainLayout,
    roles: ['ROLE_SETTING_PRINTER', 'ROLE_SETTING_PRINTER_LIST'],
  },
  setting_label_printer_list: {
    path: '/setting/label-printer/list',
    view: SettingLabelPrinterList,
    layout: MainLayout,
    roles: ['ROLE_SETTING_LABEL_PRINTER', 'ROLE_SETTING_LABEL_PRINTER_LIST'],
  },
  setting_tva_country_list: {
    path: '/setting/tva-country/list',
    view: SettingTvaCountryList,
    layout: MainLayout,
    roles: ['ROLE_SETTING_TVA_COUNTRY', 'ROLE_SETTING_TVA_COUNTRY_LIST'],
  },

  // Administrator
  administrator_user_list: {
    path: '/administrator/user/list',
    view: AdministratorUserList,
    layout: MainLayout,
    roles: ['ROLE_ADMINISTRATOR_USER', 'ROLE_ADMINISTRATOR_USER_LIST'],
  },
  administrator_user: {
    path: '/administrator/user/:id',
    match: /\/administrator\/user.*/,
    view: AdministratorUser,
    layout: MainLayout,
    roles: ['ROLE_ADMINISTRATOR_USER', 'ROLE_ADMINISTRATOR_USER_ADD'],
  },
  administrator_log_sylius_list: {
    path: '/administrator/log-sylius/list',
    view: AdministratorLogSyliusList,
    layout: MainLayout,
    roles: ['ROLE_ADMINISTRATOR_LOG_SYLIUS', 'ROLE_ADMINISTRATOR_LOG_SYLIUS_LIST'],
  },
  administrator_log_printer_list: {
    path: '/administrator/log-printer/list',
    view: AdministratorLogPrinterList,
    layout: MainLayout,
    roles: ['ROLE_ADMINISTRATOR_LOG_PRINTER', 'ROLE_ADMINISTRATOR_LOG_PRINTER_LIST'],
  },
  administrator_log_carrier_list: {
    path: '/administrator/log-carrier/list',
    view: AdministratorLogCarrierList,
    layout: MainLayout,
    roles: ['ROLE_ADMINISTRATOR_LOG_CARRIER', 'ROLE_ADMINISTRATOR_LOG_CARRIER_LIST'],
  },
  administrator_request_async_list: {
    path: '/administrator/request-async/list',
    view: AdministratorRequestAsyncList,
    layout: MainLayout,
    roles: ['ROLE_ADMINISTRATOR_REQUEST_ASYNC', 'ROLE_ADMINISTRATOR_REQUEST_ASYNC_LIST'],
  },

  // Statistic
  statistic_preparations: {
    path: '/statistic/preparations',
    view: StatisticPreparation,
    layout: MainLayout,
    roles: ['ROLE_STATS_LUCY', 'ROLE_STATS_LUCY_PREPARATEUR'],
  },
  statistic_sale_payment: {
    path: '/statistic/sale/payment',
    view: StatisticSalePayment,
    layout: MainLayout,
    roles: ['ROLE_STATS_LUCY', 'ROLE_STATS_LUCY_CA_PAYMENT'],
  },
  statistic_trades: {
    path: '/statistic/trades',
    view: StatisticTrade,
    layout: MainLayout,
    roles: ['ROLE_STATS_LUCY', 'ROLE_STATS_LUCY_CACHANNELS'],
  },
  statistic_trades_retail: {
    path: '/statistic/trades/retail',
    view: StatisticTradeRetail,
    layout: MainLayout,
    roles: ['ROLE_STATS_LUCY', 'ROLE_STATS_LUCY_RETAIL'],
  },
  statistic_marks: {
    path: '/statistic/marks',
    view: StatisticMark,
    layout: MainLayout,
    roles: ['ROLE_STATS_LUCY', 'ROLE_STATS_LUCY_BY_MARK'],
  },
  statistic_buy_ca: {
    path: '/statistic/buy/ca',
    view: StatisticBuyCa,
    layout: MainLayout,
    roles: ['ROLE_STATS_LUCY', 'ROLE_STATS_LUCY_BUY_CA'],
  },
  statistic_buy_portfolio_details: {
    path: '/statistic/buy/portfolio-details',
    view: StatisticBuyPortfolioDetails,
    layout: MainLayout,
    roles: ['ROLE_STATS_LUCY', 'ROLE_STATS_LUCY_BUY_PORTFOLIO_DETAILS'],
  },
  statistic_sale_order_reports: {
    path: '/statistic/sale/order-reports',
    view: StatisticSaleOrderReports,
    layout: MainLayout,
    roles: ['ROLE_STATS_LUCY', 'ROLE_STATS_LUCY_REPORTING'],
  },
  statistic_sales_month: {
    path: '/buy/statistics/sales',
    view: SalesStatisticsList,
    layout: MainLayout,
    roles: ['ROLE_STATS_LUCY', 'ROLE_STATS_LUCY_CA_PAYMENT'],
  },
  statistic_sales_last_12_months: {
    path: '/statistic/sale/last-12-months',
    view: SalesLast12Months,
    layout: MainLayout,
    roles: ['ROLE_STATS_LUCY', 'ROLE_STATS_LUCY_CA_PAYMENT', 'ROLE_STATS_LUCY_REPORTING'],
  },
  statistic_orders: {
    path: '/statistic/orders',
    view: StatisticOrder,
    layout: MainLayout,
    roles: ['ROLE_STATS_LUCY'],
  },

  // Shop
  shop: {
    path: '/shop',
    view: ShopCashRegister,
    layout: ShopLayout,
    roles: ['ROLE_SHOP'],
  },
  shop_closing: {
    path: '/shop/close',
    view: ShopCashRegisterClosed,
    layout: ShopLayout,
    roles: ['ROLE_SHOP'],
  },
  shop_reappro_create: {
    path: '/shop/reappro/create',
    view: CreateReappro,
    layout: ShopLayout,
    roles: ['ROLE_SHOP'],
  },
  shop_reappro_reception: {
    path: '/shop/reappro/reception/:reapproId',
    match: /\/shop\/reappro\/reception.*/,
    view: ReceptionReappro,
    layout: ShopLayout,
    roles: ['ROLE_SHOP'],
  },
  shop_list_products: {
    path: '/shop/products-shop/:shopId',
    match: /\/shop\/products-shop.*/,
    view: ShopProductsList,
    layout: ShopLayout,
    roles: ['ROLE_SHOP'],
  },
  shop_sales_list: {
    path: '/shop/sales/list/:shopId',
    match: /\/shop\/sales\/list.*/,
    view: ShopSalesList,
    layout: ShopLayout,
    roles: ['ROLE_SHOP', 'ROLE_SHOP_SALES_LIST'],
  },
  shop_sales_list_today: {
    path: '/shop/sales/list/today/:shopId',
    match: /\/shop\/sales\/list\/today.*/,
    view: ShopSalesListToday,
    layout: ShopLayout,
    roles: ['ROLE_SHOP', 'ROLE_SHOP_SALES_LIST'],
  },
  shop_sales_client_list: {
    path: '/shop/sales/client/list/:shopId',
    match: /\/shop\/sales\/client\/list.*/,
    view: SelectClient,
    layout: ShopLayout,
    roles: ['ROLE_SHOP', 'ROLE_SHOP_SALES_LIST'],
  },
  shop_sales_client_edit: {
    path: '/shop/sales/client/edit/:uuid',
    match: /\/shop\/sales\/client\/edit.*/,
    view: EditClient,
    layout: ShopLayout,
    roles: ['ROLE_SHOP', 'ROLE_SHOP_SALES_LIST'],
  },
  shop_sales_select_products: {
    path: '/shop/sales/products/select/:shopId/:clientId',
    match: /\/shop\/sales\/products\/select.*/,
    view: SelectProducts,
    layout: ShopLayout,
    roles: ['ROLE_SHOP', 'ROLE_SHOP_SALES_LIST'],
  },
  shop_sales_sign_opening: {
    path: '/shop/sign',
    view: ShopCashSignOpening,
    layout: ShopLayout,
    roles: ['ROLE_SHOP'],
  },
  shop_seller_order_client: {
    path: '/shop/seller/order-client/:uuid',
    match: /\/shop\/seller\/order-client.*/,
    view: ShopSaleOrderClient,
    layout: ShopLayout,
    roles: ['ROLE_SHOP', 'ROLE_SHOP_SALES_LIST'],
  },
  shop_reappro_list: {
    path: '/shop/reappro/list/:shopId',
    match: /\/shop\/reappro\/list.*/,
    view: ListReappro,
    layout: ShopLayout,
    roles: ['ROLE_SHOP', 'ROLE_SHOP_SALES_LIST'],
  },
};

let routes: Record<string, RouteConfig> = {};
let defaultPath: string = '/';

// Security
export const updateRouting = (authenticationReducer: ReturnType<typeof AuthenticationReducer>): void => {
  routes = {};

  if (authenticationReducer && Object.entries(authenticationReducer).length > 0) {
    // Login
    for (const index in routing) {
      if (authenticationReducer.roles.filter((value) => routing[index].roles.includes(value)).length > 0) {
        routes[index] = routing[index];
      }
    }

    if (authenticationReducer.defaultRoute && routes[authenticationReducer.defaultRoute]) {
      defaultPath = routes[authenticationReducer.defaultRoute].path;
    } else if (Object.keys(routes)[0]) {
      defaultPath = routes[Object.keys(routes)[0]].path;
    } else {
      // Logout
      routes.forgot_password_request = routing.forgot_password_request;
      routes.reset_password = routing.reset_password;
      routes.authentication_login = routing.authentication_login;
      defaultPath = getRoutePathname('authentication_login');
    }
  } else {
    // Logout
    routes.authentication_login = routing.authentication_login;
    defaultPath = getRoutePathname('authentication_login');
  }
};

export const getRoutes = (): Record<string, RouteConfig> => routes;

export const getPathDefault = (): string => defaultPath;

export const getRoute = (id: string): (RouteConfig & { id: string }) | null => {
  return routes[id] ? { ...routes[id], id } : null;
};

export const getRoutePathname = (id: string, params: Record<string, string | number> = {}): string => {
  const route = getRoute(id) as RouteConfig;
  let path = route?.path || '/';
  for (const [key, value] of Object.entries(params)) {
    path = path.replace(new RegExp(`/:${key}\\??`, 'g'), value ? `/${value}` : '');
  }
  return path;
};
